import {CellRenderContext, IGridCellRenderer} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {TextHeaderCell} from '@mintdata-wsp/wsp/ui/components/grid/cells/columnHeader/TextHeaderCell';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./TextHeaderCell.less');
const cx = classnames.bind(styles);

export class TextHeaderCellRenderer implements IGridCellRenderer
{
    render(ctx:CellRenderContext):React.ReactElement<any>
    {
        const aCell = ctx.cell as TextHeaderCell;
        const eStyle = this._computeEffectiveStyle(ctx, aCell);

        return <span key={ctx.key}
                     style={eStyle}
                     className={cx('textHeaderCell',
                         {'measureLayout': ctx.isForMeasurement},
                         {'renderLayout': !ctx.isForMeasurement},
                         ctx.className)}
                     ref={ctx.ref}>

                    {aCell.text}

                </span>;
    }

    private _computeEffectiveStyle(ctx:CellRenderContext, aCell)
    {
        if( !ctx.isForMeasurement )
            return ctx.style;

        const basis = aCell.getBasis();
        const measureStyle =
            {
                display: 'flex',
                flexBasis: basis.isFixedLength ?
                    basis.fixedLength + 'px' :
                    (basis.stretchBasis * 100.0) + '%'
            };

        return Object.assign({}, ctx.style, measureStyle);
    }
}
